module.exports = __webpack_public_path__ + "static/media/Cover.b1b68719.jpg";